"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertEmptySpaces = convertEmptySpaces;

function convertEmptySpaces(html) {
  if (!html) {
    return html;
  }

  return html.replace(/\<p\>(\s*|\&nbsp;)\<\/p\>/g, '<br/>');
}